import { IDateFilterParams } from '@mint-lib/ag-grid/community';

export const dateFilterParams: IDateFilterParams = {
  comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
    if (cellValue == null) return -1;

    const fullDate = new Date(cellValue);

    const dateOnly = new Date(
      fullDate.getFullYear(),
      fullDate.getMonth(),
      fullDate.getDate(),
    );

    if (dateOnly < filterLocalDateAtMidnight) {
      return -1;
    } else if (dateOnly > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  },
  closeOnApply: true,
  buttons: ['apply', 'reset'],
  minValidYear: 2000,
  maxValidYear: 2025,
};
